import { createFileRoute } from "@tanstack/react-router";
import { SITE_URL } from "@/lib/seo";
import { ApiPage } from "@/components/GoldRateApiPage";

const TITLE = "Free Live Gold Price API — Real-Time Spot Bullion JSON Feed (REST)";
const DESCRIPTION =
  "Free live gold price API. Real-time 24K, 22K & 18K spot bullion rates in USD, PKR and INR as a clean JSON REST feed. Integrate in JavaScript, Python or PHP in under 3 minutes.";
const PATH = "/developer/gold-rate-api";

function ldJson() {
  return [
    {
      "@context": "https://schema.org",
      "@type": "SoftwareSourceCode",
      name: "DrHint Live Gold Rate API",
      programmingLanguage: ["JavaScript", "Python", "PHP"],
      codeRepository: SITE_URL + PATH,
      description: DESCRIPTION,
    },
    {
      "@context": "https://schema.org",
      "@type": "WebAPI",
      name: "DrHint Gold Rate API",
      description: DESCRIPTION,
      documentation: SITE_URL + PATH,
      provider: { "@type": "Organization", name: "DrHint" },
      termsOfService: SITE_URL + "/terms",
    },
  ];
}

export const Route = createFileRoute("/developer/gold-rate-api")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { name: "keywords", content: "free live gold price api, gold rate api json, real-time bullion price feed, spot gold rest api, gold price json download, xau usd api" },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: `${SITE_URL}${PATH}` },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}${PATH}` }],
    scripts: ldJson().map((s) => ({ type: "application/ld+json", children: JSON.stringify(s) })),
  }),
  component: ApiPage,
});